/**
 * IANA Timezone Database
 * Complete list of 406 timezones with UTC offsets
 * Used across the application for timezone selection dropdowns
 */

export const TIMEZONE_LIST = [
	// UTC
	{text: "UTC UTC+00:00", value: "UTC UTC+00:00"},
	// Africa
	{text: "Africa/Abidjan UTC+00:00", value: "Africa/Abidjan UTC+00:00"},
	{text: "Africa/Accra UTC+00:00", value: "Africa/Accra UTC+00:00"},
	{text: "Africa/Addis_Ababa UTC+03:00", value: "Africa/Addis_Ababa UTC+03:00"},
	{text: "Africa/Algiers UTC+01:00", value: "Africa/Algiers UTC+01:00"},
	{text: "Africa/Asmara UTC+03:00", value: "Africa/Asmara UTC+03:00"},
	{text: "Africa/Bamako UTC+00:00", value: "Africa/Bamako UTC+00:00"},
	{text: "Africa/Bangui UTC+01:00", value: "Africa/Bangui UTC+01:00"},
	{text: "Africa/Banjul UTC+00:00", value: "Africa/Banjul UTC+00:00"},
	{text: "Africa/Bissau UTC+00:00", value: "Africa/Bissau UTC+00:00"},
	{text: "Africa/Blantyre UTC+02:00", value: "Africa/Blantyre UTC+02:00"},
	{text: "Africa/Brazzaville UTC+01:00", value: "Africa/Brazzaville UTC+01:00"},
	{text: "Africa/Bujumbura UTC+02:00", value: "Africa/Bujumbura UTC+02:00"},
	{text: "Africa/Cairo UTC+02:00", value: "Africa/Cairo UTC+02:00"},
	{text: "Africa/Casablanca UTC+00:00", value: "Africa/Casablanca UTC+00:00"},
	{text: "Africa/Ceuta UTC+01:00", value: "Africa/Ceuta UTC+01:00"},
	{text: "Africa/Conakry UTC+00:00", value: "Africa/Conakry UTC+00:00"},
	{text: "Africa/Dakar UTC+00:00", value: "Africa/Dakar UTC+00:00"},
	{text: "Africa/Dar_es_Salaam UTC+03:00", value: "Africa/Dar_es_Salaam UTC+03:00"},
	{text: "Africa/Djibouti UTC+03:00", value: "Africa/Djibouti UTC+03:00"},
	{text: "Africa/Douala UTC+01:00", value: "Africa/Douala UTC+01:00"},
	{text: "Africa/El_Aaiun UTC+00:00", value: "Africa/El_Aaiun UTC+00:00"},
	{text: "Africa/Freetown UTC+00:00", value: "Africa/Freetown UTC+00:00"},
	{text: "Africa/Gaborone UTC+02:00", value: "Africa/Gaborone UTC+02:00"},
	{text: "Africa/Harare UTC+02:00", value: "Africa/Harare UTC+02:00"},
	{text: "Africa/Johannesburg UTC+02:00", value: "Africa/Johannesburg UTC+02:00"},
	{text: "Africa/Juba UTC+03:00", value: "Africa/Juba UTC+03:00"},
	{text: "Africa/Kampala UTC+03:00", value: "Africa/Kampala UTC+03:00"},
	{text: "Africa/Khartoum UTC+03:00", value: "Africa/Khartoum UTC+03:00"},
	{text: "Africa/Kigali UTC+02:00", value: "Africa/Kigali UTC+02:00"},
	{text: "Africa/Kinshasa UTC+01:00", value: "Africa/Kinshasa UTC+01:00"},
	{text: "Africa/Lagos UTC+01:00", value: "Africa/Lagos UTC+01:00"},
	{text: "Africa/Libreville UTC+01:00", value: "Africa/Libreville UTC+01:00"},
	{text: "Africa/Lome UTC+00:00", value: "Africa/Lome UTC+00:00"},
	{text: "Africa/Luanda UTC+01:00", value: "Africa/Luanda UTC+01:00"},
	{text: "Africa/Lubumbashi UTC+02:00", value: "Africa/Lubumbashi UTC+02:00"},
	{text: "Africa/Lusaka UTC+02:00", value: "Africa/Lusaka UTC+02:00"},
	{text: "Africa/Malabo UTC+01:00", value: "Africa/Malabo UTC+01:00"},
	{text: "Africa/Maputo UTC+02:00", value: "Africa/Maputo UTC+02:00"},
	{text: "Africa/Maseru UTC+02:00", value: "Africa/Maseru UTC+02:00"},
	{text: "Africa/Mbabane UTC+02:00", value: "Africa/Mbabane UTC+02:00"},
	{text: "Africa/Mogadishu UTC+03:00", value: "Africa/Mogadishu UTC+03:00"},
	{text: "Africa/Monrovia UTC+00:00", value: "Africa/Monrovia UTC+00:00"},
	{text: "Africa/Montserrado UTC+00:00", value: "Africa/Montserrado UTC+00:00"},
	{text: "Africa/Nairobi UTC+03:00", value: "Africa/Nairobi UTC+03:00"},
	{text: "Africa/Ndjamena UTC+01:00", value: "Africa/Ndjamena UTC+01:00"},
	{text: "Africa/Niamey UTC+01:00", value: "Africa/Niamey UTC+01:00"},
	{text: "Africa/Nouakchott UTC+00:00", value: "Africa/Nouakchott UTC+00:00"},
	{text: "Africa/Ouagadougou UTC+00:00", value: "Africa/Ouagadougou UTC+00:00"},
	{text: "Africa/Porto-Novo UTC+01:00", value: "Africa/Porto-Novo UTC+01:00"},
	{text: "Africa/Sao_Tome UTC+00:00", value: "Africa/Sao_Tome UTC+00:00"},
	{text: "Africa/Tripoli UTC+02:00", value: "Africa/Tripoli UTC+02:00"},
	{text: "Africa/Tunis UTC+01:00", value: "Africa/Tunis UTC+01:00"},
	{text: "Africa/Windhoek UTC+02:00", value: "Africa/Windhoek UTC+02:00"},
	// America - North
	{text: "America/Anchorage UTC-09:00", value: "America/Anchorage UTC-09:00"},
	{text: "America/Boise UTC-07:00", value: "America/Boise UTC-07:00"},
	{text: "America/Chicago UTC-06:00", value: "America/Chicago UTC-06:00"},
	{text: "America/Denver UTC-07:00", value: "America/Denver UTC-07:00"},
	{text: "America/Detroit UTC-05:00", value: "America/Detroit UTC-05:00"},
	{text: "America/Indiana/Indianapolis UTC-05:00", value: "America/Indiana/Indianapolis UTC-05:00"},
	{text: "America/Indiana/Knox UTC-06:00", value: "America/Indiana/Knox UTC-06:00"},
	{text: "America/Indiana/Marengo UTC-05:00", value: "America/Indiana/Marengo UTC-05:00"},
	{text: "America/Indiana/Petersburg UTC-05:00", value: "America/Indiana/Petersburg UTC-05:00"},
	{text: "America/Indiana/Tell_City UTC-06:00", value: "America/Indiana/Tell_City UTC-06:00"},
	{text: "America/Indiana/Vevay UTC-05:00", value: "America/Indiana/Vevay UTC-05:00"},
	{text: "America/Indiana/Vincennes UTC-05:00", value: "America/Indiana/Vincennes UTC-05:00"},
	{text: "America/Indiana/Winamac UTC-05:00", value: "America/Indiana/Winamac UTC-05:00"},
	{text: "America/Juneau UTC-09:00", value: "America/Juneau UTC-09:00"},
	{text: "America/Kentucky/Louisville UTC-05:00", value: "America/Kentucky/Louisville UTC-05:00"},
	{text: "America/Kentucky/Monticello UTC-05:00", value: "America/Kentucky/Monticello UTC-05:00"},
	{text: "America/Los_Angeles UTC-08:00", value: "America/Los_Angeles UTC-08:00"},
	{text: "America/Menominee UTC-06:00", value: "America/Menominee UTC-06:00"},
	{text: "America/Metlakatla UTC-09:00", value: "America/Metlakatla UTC-09:00"},
	{text: "America/New_York UTC-05:00", value: "America/New_York UTC-05:00"},
	{text: "America/Nome UTC-09:00", value: "America/Nome UTC-09:00"},
	{text: "America/North_Dakota/Beulah UTC-06:00", value: "America/North_Dakota/Beulah UTC-06:00"},
	{text: "America/North_Dakota/Center UTC-06:00", value: "America/North_Dakota/Center UTC-06:00"},
	{text: "America/North_Dakota/New_Salem UTC-06:00", value: "America/North_Dakota/New_Salem UTC-06:00"},
	{text: "America/Phoenix UTC-07:00", value: "America/Phoenix UTC-07:00"},
	{text: "America/Sitka UTC-09:00", value: "America/Sitka UTC-09:00"},
	{text: "America/Toronto UTC-05:00", value: "America/Toronto UTC-05:00"},
	{text: "America/Vancouver UTC-08:00", value: "America/Vancouver UTC-08:00"},
	{text: "America/Winnipeg UTC-06:00", value: "America/Winnipeg UTC-06:00"},
	// America - Central & South
	{text: "America/Belmopan UTC-06:00", value: "America/Belmopan UTC-06:00"},
	{text: "America/Costa_Rica UTC-06:00", value: "America/Costa_Rica UTC-06:00"},
	{text: "America/El_Salvador UTC-06:00", value: "America/El_Salvador UTC-06:00"},
	{text: "America/Guatemala UTC-06:00", value: "America/Guatemala UTC-06:00"},
	{text: "America/Guayaquil UTC-05:00", value: "America/Guayaquil UTC-05:00"},
	{text: "America/Havana UTC-05:00", value: "America/Havana UTC-05:00"},
	{text: "America/Hermosillo UTC-07:00", value: "America/Hermosillo UTC-07:00"},
	{text: "America/Jamaica UTC-05:00", value: "America/Jamaica UTC-05:00"},
	{text: "America/Mexico_City UTC-06:00", value: "America/Mexico_City UTC-06:00"},
	{text: "America/Monterrey UTC-06:00", value: "America/Monterrey UTC-06:00"},
	{text: "America/Tegucigalpa UTC-06:00", value: "America/Tegucigalpa UTC-06:00"},
	// America - South
	{text: "America/Antigua UTC-04:00", value: "America/Antigua UTC-04:00"},
	{text: "America/Argentina/Buenos_Aires UTC-03:00", value: "America/Argentina/Buenos_Aires UTC-03:00"},
	{text: "America/Argentina/Catamarca UTC-03:00", value: "America/Argentina/Catamarca UTC-03:00"},
	{text: "America/Argentina/ComodRivadavia UTC-03:00", value: "America/Argentina/ComodRivadavia UTC-03:00"},
	{text: "America/Argentina/Cordoba UTC-03:00", value: "America/Argentina/Cordoba UTC-03:00"},
	{text: "America/Argentina/Jujuy UTC-03:00", value: "America/Argentina/Jujuy UTC-03:00"},
	{text: "America/Argentina/La_Rioja UTC-03:00", value: "America/Argentina/La_Rioja UTC-03:00"},
	{text: "America/Argentina/Mendoza UTC-03:00", value: "America/Argentina/Mendoza UTC-03:00"},
	{text: "America/Argentina/Rio_Gallegos UTC-03:00", value: "America/Argentina/Rio_Gallegos UTC-03:00"},
	{text: "America/Argentina/Salta UTC-03:00", value: "America/Argentina/Salta UTC-03:00"},
	{text: "America/Argentina/San_Juan UTC-03:00", value: "America/Argentina/San_Juan UTC-03:00"},
	{text: "America/Argentina/San_Luis UTC-03:00", value: "America/Argentina/San_Luis UTC-03:00"},
	{text: "America/Argentina/Tucuman UTC-03:00", value: "America/Argentina/Tucuman UTC-03:00"},
	{text: "America/Argentina/Ushuaia UTC-03:00", value: "America/Argentina/Ushuaia UTC-03:00"},
	{text: "America/Aruba UTC-04:00", value: "America/Aruba UTC-04:00"},
	{text: "America/Barbados UTC-04:00", value: "America/Barbados UTC-04:00"},
	{text: "America/Boa_Vista UTC-04:00", value: "America/Boa_Vista UTC-04:00"},
	{text: "America/Bogota UTC-05:00", value: "America/Bogota UTC-05:00"},
	{text: "America/Buenos_Aires UTC-03:00", value: "America/Buenos_Aires UTC-03:00"},
	{text: "America/Caracas UTC-04:00", value: "America/Caracas UTC-04:00"},
	{text: "America/Cayenne UTC-03:00", value: "America/Cayenne UTC-03:00"},
	{text: "America/Cayman UTC-05:00", value: "America/Cayman UTC-05:00"},
	{text: "America/Curacao UTC-04:00", value: "America/Curacao UTC-04:00"},
	{text: "America/Dominica UTC-04:00", value: "America/Dominica UTC-04:00"},
	{text: "America/Dominican UTC-04:00", value: "America/Dominican UTC-04:00"},
	{text: "America/Fort_Wayne UTC-05:00", value: "America/Fort_Wayne UTC-05:00"},
	{text: "America/Godthab UTC-03:00", value: "America/Godthab UTC-03:00"},
	{text: "America/Grenada UTC-04:00", value: "America/Grenada UTC-04:00"},
	{text: "America/Guadeloupe UTC-04:00", value: "America/Guadeloupe UTC-04:00"},
	{text: "America/Guyana UTC-04:00", value: "America/Guyana UTC-04:00"},
	{text: "America/Halifax UTC-04:00", value: "America/Halifax UTC-04:00"},
	{text: "America/La_Paz UTC-04:00", value: "America/La_Paz UTC-04:00"},
	{text: "America/Lima UTC-05:00", value: "America/Lima UTC-05:00"},
	{text: "America/Maceio UTC-03:00", value: "America/Maceio UTC-03:00"},
	{text: "America/Managua UTC-06:00", value: "America/Managua UTC-06:00"},
	{text: "America/Manaus UTC-04:00", value: "America/Manaus UTC-04:00"},
	{text: "America/Marigot UTC-04:00", value: "America/Marigot UTC-04:00"},
	{text: "America/Martinique UTC-04:00", value: "America/Martinique UTC-04:00"},
	{text: "America/Matamoros UTC-06:00", value: "America/Matamoros UTC-06:00"},
	{text: "America/Miquelon UTC-03:00", value: "America/Miquelon UTC-03:00"},
	{text: "America/Montevideo UTC-03:00", value: "America/Montevideo UTC-03:00"},
	{text: "America/Montserrat UTC-04:00", value: "America/Montserrat UTC-04:00"},
	{text: "America/Nassau UTC-05:00", value: "America/Nassau UTC-05:00"},
	{text: "America/Paramaribo UTC-03:00", value: "America/Paramaribo UTC-03:00"},
	{text: "America/Port-au-Prince UTC-05:00", value: "America/Port-au-Prince UTC-05:00"},
	{text: "America/Port_of_Spain UTC-04:00", value: "America/Port_of_Spain UTC-04:00"},
	{text: "America/Puerto_Rico UTC-04:00", value: "America/Puerto_Rico UTC-04:00"},
	{text: "America/Recife UTC-03:00", value: "America/Recife UTC-03:00"},
	{text: "America/Regina UTC-06:00", value: "America/Regina UTC-06:00"},
	{text: "America/Sao_Paulo UTC-03:00", value: "America/Sao_Paulo UTC-03:00"},
	{text: "America/Scoresbysund UTC-01:00", value: "America/Scoresbysund UTC-01:00"},
	{text: "America/St_Barthelemy UTC-04:00", value: "America/St_Barthelemy UTC-04:00"},
	{text: "America/St_Johns UTC-03:30", value: "America/St_Johns UTC-03:30"},
	{text: "America/St_Kitts UTC-04:00", value: "America/St_Kitts UTC-04:00"},
	{text: "America/St_Lucia UTC-04:00", value: "America/St_Lucia UTC-04:00"},
	{text: "America/St_Thomas UTC-04:00", value: "America/St_Thomas UTC-04:00"},
	{text: "America/St_Vincent UTC-04:00", value: "America/St_Vincent UTC-04:00"},
	{text: "America/Swift_Current UTC-06:00", value: "America/Swift_Current UTC-06:00"},
	{text: "America/Thule UTC-04:00", value: "America/Thule UTC-04:00"},
	{text: "America/Thunder_Bay UTC-05:00", value: "America/Thunder_Bay UTC-05:00"},
	{text: "America/Tortola UTC-04:00", value: "America/Tortola UTC-04:00"},
	{text: "America/Virgin UTC-04:00", value: "America/Virgin UTC-04:00"},
	// Asia
	{text: "Asia/Aden UTC+03:00", value: "Asia/Aden UTC+03:00"},
	{text: "Asia/Almaty UTC+06:00", value: "Asia/Almaty UTC+06:00"},
	{text: "Asia/Amman UTC+02:00", value: "Asia/Amman UTC+02:00"},
	{text: "Asia/Anadyr UTC+12:00", value: "Asia/Anadyr UTC+12:00"},
	{text: "Asia/Aqtau UTC+04:00", value: "Asia/Aqtau UTC+04:00"},
	{text: "Asia/Aqtobe UTC+05:00", value: "Asia/Aqtobe UTC+05:00"},
	{text: "Asia/Ashgabat UTC+05:00", value: "Asia/Ashgabat UTC+05:00"},
	{text: "Asia/Ashkhabad UTC+05:00", value: "Asia/Ashkhabad UTC+05:00"},
	{text: "Asia/Baghdad UTC+03:00", value: "Asia/Baghdad UTC+03:00"},
	{text: "Asia/Bahrain UTC+03:00", value: "Asia/Bahrain UTC+03:00"},
	{text: "Asia/Baku UTC+04:00", value: "Asia/Baku UTC+04:00"},
	{text: "Asia/Bangkok UTC+07:00", value: "Asia/Bangkok UTC+07:00"},
	{text: "Asia/Beirut UTC+02:00", value: "Asia/Beirut UTC+02:00"},
	{text: "Asia/Bishkek UTC+06:00", value: "Asia/Bishkek UTC+06:00"},
	{text: "Asia/Brunei UTC+08:00", value: "Asia/Brunei UTC+08:00"},
	{text: "Asia/Calcutta UTC+05:30", value: "Asia/Calcutta UTC+05:30"},
	{text: "Asia/Chita UTC+09:00", value: "Asia/Chita UTC+09:00"},
	{text: "Asia/Choibalsan UTC+08:00", value: "Asia/Choibalsan UTC+08:00"},
	{text: "Asia/Chongqing UTC+08:00", value: "Asia/Chongqing UTC+08:00"},
	{text: "Asia/Chungking UTC+08:00", value: "Asia/Chungking UTC+08:00"},
	{text: "Asia/Colombo UTC+05:30", value: "Asia/Colombo UTC+05:30"},
	{text: "Asia/Dacca UTC+06:00", value: "Asia/Dacca UTC+06:00"},
	{text: "Asia/Damascus UTC+02:00", value: "Asia/Damascus UTC+02:00"},
	{text: "Asia/Dhaka UTC+06:00", value: "Asia/Dhaka UTC+06:00"},
	{text: "Asia/Dili UTC+09:00", value: "Asia/Dili UTC+09:00"},
	{text: "Asia/Dubai UTC+04:00", value: "Asia/Dubai UTC+04:00"},
	{text: "Asia/Dushanbe UTC+05:00", value: "Asia/Dushanbe UTC+05:00"},
	{text: "Asia/Famagusta UTC+02:00", value: "Asia/Famagusta UTC+02:00"},
	{text: "Asia/Gaza UTC+02:00", value: "Asia/Gaza UTC+02:00"},
	{text: "Asia/Harbin UTC+08:00", value: "Asia/Harbin UTC+08:00"},
	{text: "Asia/Hebron UTC+02:00", value: "Asia/Hebron UTC+02:00"},
	{text: "Asia/Ho_Chi_Minh UTC+07:00", value: "Asia/Ho_Chi_Minh UTC+07:00"},
	{text: "Asia/Hong_Kong UTC+08:00", value: "Asia/Hong_Kong UTC+08:00"},
	{text: "Asia/Hovd UTC+07:00", value: "Asia/Hovd UTC+07:00"},
	{text: "Asia/Irkutsk UTC+08:00", value: "Asia/Irkutsk UTC+08:00"},
	{text: "Asia/Istanbul UTC+03:00", value: "Asia/Istanbul UTC+03:00"},
	{text: "Asia/Jakarta UTC+07:00", value: "Asia/Jakarta UTC+07:00"},
	{text: "Asia/Jayapura UTC+09:00", value: "Asia/Jayapura UTC+09:00"},
	{text: "Asia/Jerusalem UTC+02:00", value: "Asia/Jerusalem UTC+02:00"},
	{text: "Asia/Kabul UTC+04:30", value: "Asia/Kabul UTC+04:30"},
	{text: "Asia/Kamchatka UTC+12:00", value: "Asia/Kamchatka UTC+12:00"},
	{text: "Asia/Karachi UTC+05:00", value: "Asia/Karachi UTC+05:00"},
	{text: "Asia/Kashgar UTC+08:00", value: "Asia/Kashgar UTC+08:00"},
	{text: "Asia/Kathmandu UTC+05:45", value: "Asia/Kathmandu UTC+05:45"},
	{text: "Asia/Katmandu UTC+05:45", value: "Asia/Katmandu UTC+05:45"},
	{text: "Asia/Khandyga UTC+09:00", value: "Asia/Khandyga UTC+09:00"},
	{text: "Asia/Kolkata UTC+05:30", value: "Asia/Kolkata UTC+05:30"},
	{text: "Asia/Krasnoyarsk UTC+07:00", value: "Asia/Krasnoyarsk UTC+07:00"},
	{text: "Asia/Kuala_Lumpur UTC+08:00", value: "Asia/Kuala_Lumpur UTC+08:00"},
	{text: "Asia/Kuching UTC+08:00", value: "Asia/Kuching UTC+08:00"},
	{text: "Asia/Kuwait UTC+03:00", value: "Asia/Kuwait UTC+03:00"},
	{text: "Asia/Macao UTC+08:00", value: "Asia/Macao UTC+08:00"},
	{text: "Asia/Macau UTC+08:00", value: "Asia/Macau UTC+08:00"},
	{text: "Asia/Magadan UTC+11:00", value: "Asia/Magadan UTC+11:00"},
	{text: "Asia/Makassar UTC+08:00", value: "Asia/Makassar UTC+08:00"},
	{text: "Asia/Manila UTC+08:00", value: "Asia/Manila UTC+08:00"},
	{text: "Asia/Muscat UTC+04:00", value: "Asia/Muscat UTC+04:00"},
	{text: "Asia/Nicosia UTC+02:00", value: "Asia/Nicosia UTC+02:00"},
	{text: "Asia/Novokuznetsk UTC+07:00", value: "Asia/Novokuznetsk UTC+07:00"},
	{text: "Asia/Novosibirsk UTC+07:00", value: "Asia/Novosibirsk UTC+07:00"},
	{text: "Asia/Omsk UTC+06:00", value: "Asia/Omsk UTC+06:00"},
	{text: "Asia/Oral UTC+05:00", value: "Asia/Oral UTC+05:00"},
	{text: "Asia/Phnom_Penh UTC+07:00", value: "Asia/Phnom_Penh UTC+07:00"},
	{text: "Asia/Pontianak UTC+07:00", value: "Asia/Pontianak UTC+07:00"},
	{text: "Asia/Pyongyang UTC+09:00", value: "Asia/Pyongyang UTC+09:00"},
	{text: "Asia/Qatar UTC+03:00", value: "Asia/Qatar UTC+03:00"},
	{text: "Asia/Qyzylorda UTC+06:00", value: "Asia/Qyzylorda UTC+06:00"},
	{text: "Asia/Rangoon UTC+06:30", value: "Asia/Rangoon UTC+06:30"},
	{text: "Asia/Riyadh UTC+03:00", value: "Asia/Riyadh UTC+03:00"},
	{text: "Asia/Saigon UTC+07:00", value: "Asia/Saigon UTC+07:00"},
	{text: "Asia/Sakhalin UTC+11:00", value: "Asia/Sakhalin UTC+11:00"},
	{text: "Asia/Samarkand UTC+05:00", value: "Asia/Samarkand UTC+05:00"},
	{text: "Asia/Seoul UTC+09:00", value: "Asia/Seoul UTC+09:00"},
	{text: "Asia/Shanghai UTC+08:00", value: "Asia/Shanghai UTC+08:00"},
	{text: "Asia/Singapore UTC+08:00", value: "Asia/Singapore UTC+08:00"},
	{text: "Asia/Srednekolymsk UTC+11:00", value: "Asia/Srednekolymsk UTC+11:00"},
	{text: "Asia/Taipei UTC+08:00", value: "Asia/Taipei UTC+08:00"},
	{text: "Asia/Tashkent UTC+05:00", value: "Asia/Tashkent UTC+05:00"},
	{text: "Asia/Tbilisi UTC+04:00", value: "Asia/Tbilisi UTC+04:00"},
	{text: "Asia/Tehran UTC+03:30", value: "Asia/Tehran UTC+03:30"},
	{text: "Asia/Tel_Aviv UTC+02:00", value: "Asia/Tel_Aviv UTC+02:00"},
	{text: "Asia/Thimbu UTC+06:00", value: "Asia/Thimbu UTC+06:00"},
	{text: "Asia/Thimphu UTC+06:00", value: "Asia/Thimphu UTC+06:00"},
	{text: "Asia/Tokyo UTC+09:00", value: "Asia/Tokyo UTC+09:00"},
	{text: "Asia/Tomsk UTC+07:00", value: "Asia/Tomsk UTC+07:00"},
	{text: "Asia/Ujung_Pandang UTC+08:00", value: "Asia/Ujung_Pandang UTC+08:00"},
	{text: "Asia/Ulaanbaatar UTC+08:00", value: "Asia/Ulaanbaatar UTC+08:00"},
	{text: "Asia/Ulan_Bator UTC+08:00", value: "Asia/Ulan_Bator UTC+08:00"},
	{text: "Asia/Urumqi UTC+08:00", value: "Asia/Urumqi UTC+08:00"},
	{text: "Asia/Ust-Nera UTC+10:00", value: "Asia/Ust-Nera UTC+10:00"},
	{text: "Asia/Vientiane UTC+07:00", value: "Asia/Vientiane UTC+07:00"},
	{text: "Asia/Vladivostok UTC+10:00", value: "Asia/Vladivostok UTC+10:00"},
	{text: "Asia/Yakutsk UTC+09:00", value: "Asia/Yakutsk UTC+09:00"},
	{text: "Asia/Yekaterinburg UTC+05:00", value: "Asia/Yekaterinburg UTC+05:00"},
	{text: "Asia/Yerushalayim UTC+02:00", value: "Asia/Yerushalayim UTC+02:00"},
	{text: "Asia/Yerevan UTC+04:00", value: "Asia/Yerevan UTC+04:00"},
	// Atlantic
	{text: "Atlantic/Azores UTC-01:00", value: "Atlantic/Azores UTC-01:00"},
	{text: "Atlantic/Bermuda UTC-04:00", value: "Atlantic/Bermuda UTC-04:00"},
	{text: "Atlantic/Canary UTC+00:00", value: "Atlantic/Canary UTC+00:00"},
	{text: "Atlantic/Cape_Verde UTC-01:00", value: "Atlantic/Cape_Verde UTC-01:00"},
	{text: "Atlantic/Faeroe UTC+00:00", value: "Atlantic/Faeroe UTC+00:00"},
	{text: "Atlantic/Faroe UTC+00:00", value: "Atlantic/Faroe UTC+00:00"},
	{text: "Atlantic/Jan_Mayen UTC+01:00", value: "Atlantic/Jan_Mayen UTC+01:00"},
	{text: "Atlantic/Madeira UTC+00:00", value: "Atlantic/Madeira UTC+00:00"},
	{text: "Atlantic/Reykjavik UTC+00:00", value: "Atlantic/Reykjavik UTC+00:00"},
	{text: "Atlantic/South_Georgia UTC-02:00", value: "Atlantic/South_Georgia UTC-02:00"},
	{text: "Atlantic/St_Helena UTC+00:00", value: "Atlantic/St_Helena UTC+00:00"},
	{text: "Atlantic/Stanley UTC-03:00", value: "Atlantic/Stanley UTC-03:00"},
	// Australia
	{text: "Australia/ACT UTC+10:00", value: "Australia/ACT UTC+10:00"},
	{text: "Australia/Adelaide UTC+09:30", value: "Australia/Adelaide UTC+09:30"},
	{text: "Australia/Brisbane UTC+10:00", value: "Australia/Brisbane UTC+10:00"},
	{text: "Australia/Broken_Hill UTC+09:30", value: "Australia/Broken_Hill UTC+09:30"},
	{text: "Australia/Canberra UTC+10:00", value: "Australia/Canberra UTC+10:00"},
	{text: "Australia/Currie UTC+10:00", value: "Australia/Currie UTC+10:00"},
	{text: "Australia/Darwin UTC+09:30", value: "Australia/Darwin UTC+09:30"},
	{text: "Australia/Eucla UTC+08:45", value: "Australia/Eucla UTC+08:45"},
	{text: "Australia/Hobart UTC+10:00", value: "Australia/Hobart UTC+10:00"},
	{text: "Australia/LHI UTC+10:30", value: "Australia/LHI UTC+10:30"},
	{text: "Australia/Lindeman UTC+10:00", value: "Australia/Lindeman UTC+10:00"},
	{text: "Australia/Lord_Howe UTC+10:30", value: "Australia/Lord_Howe UTC+10:30"},
	{text: "Australia/Melbourne UTC+10:00", value: "Australia/Melbourne UTC+10:00"},
	{text: "Australia/North UTC+09:30", value: "Australia/North UTC+09:30"},
	{text: "Australia/NSW UTC+10:00", value: "Australia/NSW UTC+10:00"},
	{text: "Australia/Perth UTC+08:00", value: "Australia/Perth UTC+08:00"},
	{text: "Australia/Queensland UTC+10:00", value: "Australia/Queensland UTC+10:00"},
	{text: "Australia/South UTC+09:30", value: "Australia/South UTC+09:30"},
	{text: "Australia/Sydney UTC+10:00", value: "Australia/Sydney UTC+10:00"},
	{text: "Australia/Tasmania UTC+10:00", value: "Australia/Tasmania UTC+10:00"},
	{text: "Australia/Victoria UTC+10:00", value: "Australia/Victoria UTC+10:00"},
	{text: "Australia/West UTC+08:00", value: "Australia/West UTC+08:00"},
	{text: "Australia/Yancowinna UTC+09:30", value: "Australia/Yancowinna UTC+09:30"},
	// Europe
	{text: "Europe/Amsterdam UTC+01:00", value: "Europe/Amsterdam UTC+01:00"},
	{text: "Europe/Andorra UTC+01:00", value: "Europe/Andorra UTC+01:00"},
	{text: "Europe/Astrakhan UTC+04:00", value: "Europe/Astrakhan UTC+04:00"},
	{text: "Europe/Athens UTC+02:00", value: "Europe/Athens UTC+02:00"},
	{text: "Europe/Belfast UTC+00:00", value: "Europe/Belfast UTC+00:00"},
	{text: "Europe/Belgrade UTC+01:00", value: "Europe/Belgrade UTC+01:00"},
	{text: "Europe/Berlin UTC+01:00", value: "Europe/Berlin UTC+01:00"},
	{text: "Europe/Bratislava UTC+01:00", value: "Europe/Bratislava UTC+01:00"},
	{text: "Europe/Brussels UTC+01:00", value: "Europe/Brussels UTC+01:00"},
	{text: "Europe/Bucharest UTC+02:00", value: "Europe/Bucharest UTC+02:00"},
	{text: "Europe/Budapest UTC+01:00", value: "Europe/Budapest UTC+01:00"},
	{text: "Europe/Busingen UTC+01:00", value: "Europe/Busingen UTC+01:00"},
	{text: "Europe/Chisinau UTC+02:00", value: "Europe/Chisinau UTC+02:00"},
	{text: "Europe/Copenhagen UTC+01:00", value: "Europe/Copenhagen UTC+01:00"},
	{text: "Europe/Dublin UTC+00:00", value: "Europe/Dublin UTC+00:00"},
	{text: "Europe/Gibraltar UTC+01:00", value: "Europe/Gibraltar UTC+01:00"},
	{text: "Europe/Guernsey UTC+00:00", value: "Europe/Guernsey UTC+00:00"},
	{text: "Europe/Helsinki UTC+02:00", value: "Europe/Helsinki UTC+02:00"},
	{text: "Europe/Isle_of_Man UTC+00:00", value: "Europe/Isle_of_Man UTC+00:00"},
	{text: "Europe/Istanbul UTC+03:00", value: "Europe/Istanbul UTC+03:00"},
	{text: "Europe/Jersey UTC+00:00", value: "Europe/Jersey UTC+00:00"},
	{text: "Europe/Jassy UTC+02:00", value: "Europe/Jassy UTC+02:00"},
	{text: "Europe/Kaliningrad UTC+02:00", value: "Europe/Kaliningrad UTC+02:00"},
	{text: "Europe/Kiev UTC+02:00", value: "Europe/Kiev UTC+02:00"},
	{text: "Europe/Kirov UTC+03:00", value: "Europe/Kirov UTC+03:00"},
	{text: "Europe/Lisbon UTC+00:00", value: "Europe/Lisbon UTC+00:00"},
	{text: "Europe/Ljubljana UTC+01:00", value: "Europe/Ljubljana UTC+01:00"},
	{text: "Europe/London UTC+00:00", value: "Europe/London UTC+00:00"},
	{text: "Europe/Luxembourg UTC+01:00", value: "Europe/Luxembourg UTC+01:00"},
	{text: "Europe/Madrid UTC+01:00", value: "Europe/Madrid UTC+01:00"},
	{text: "Europe/Malta UTC+01:00", value: "Europe/Malta UTC+01:00"},
	{text: "Europe/Mariehamn UTC+02:00", value: "Europe/Mariehamn UTC+02:00"},
	{text: "Europe/Minsk UTC+03:00", value: "Europe/Minsk UTC+03:00"},
	{text: "Europe/Moldavia UTC+02:00", value: "Europe/Moldavia UTC+02:00"},
	{text: "Europe/Monaco UTC+01:00", value: "Europe/Monaco UTC+01:00"},
	{text: "Europe/Moscow UTC+03:00", value: "Europe/Moscow UTC+03:00"},
	{text: "Europe/Nicosia UTC+02:00", value: "Europe/Nicosia UTC+02:00"},
	{text: "Europe/Oslo UTC+01:00", value: "Europe/Oslo UTC+01:00"},
	{text: "Europe/Paris UTC+01:00", value: "Europe/Paris UTC+01:00"},
	{text: "Europe/Podgorica UTC+01:00", value: "Europe/Podgorica UTC+01:00"},
	{text: "Europe/Prague UTC+01:00", value: "Europe/Prague UTC+01:00"},
	{text: "Europe/Riga UTC+02:00", value: "Europe/Riga UTC+02:00"},
	{text: "Europe/Rome UTC+01:00", value: "Europe/Rome UTC+01:00"},
	{text: "Europe/Samara UTC+04:00", value: "Europe/Samara UTC+04:00"},
	{text: "Europe/San_Marino UTC+01:00", value: "Europe/San_Marino UTC+01:00"},
	{text: "Europe/Sarajevo UTC+01:00", value: "Europe/Sarajevo UTC+01:00"},
	{text: "Europe/Saratov UTC+04:00", value: "Europe/Saratov UTC+04:00"},
	{text: "Europe/Simferopol UTC+03:00", value: "Europe/Simferopol UTC+03:00"},
	{text: "Europe/Skopje UTC+01:00", value: "Europe/Skopje UTC+01:00"},
	{text: "Europe/Sofia UTC+02:00", value: "Europe/Sofia UTC+02:00"},
	{text: "Europe/Stockholm UTC+01:00", value: "Europe/Stockholm UTC+01:00"},
	{text: "Europe/Tallinn UTC+02:00", value: "Europe/Tallinn UTC+02:00"},
	{text: "Europe/Tirane UTC+01:00", value: "Europe/Tirane UTC+01:00"},
	{text: "Europe/Tiraspol UTC+02:00", value: "Europe/Tiraspol UTC+02:00"},
	{text: "Europe/Ulyanovsk UTC+04:00", value: "Europe/Ulyanovsk UTC+04:00"},
	{text: "Europe/Vaduz UTC+01:00", value: "Europe/Vaduz UTC+01:00"},
	{text: "Europe/Vatican UTC+01:00", value: "Europe/Vatican UTC+01:00"},
	{text: "Europe/Vienna UTC+01:00", value: "Europe/Vienna UTC+01:00"},
	{text: "Europe/Vilnius UTC+02:00", value: "Europe/Vilnius UTC+02:00"},
	{text: "Europe/Volgograd UTC+03:00", value: "Europe/Volgograd UTC+03:00"},
	{text: "Europe/Warsaw UTC+01:00", value: "Europe/Warsaw UTC+01:00"},
	{text: "Europe/Zagreb UTC+01:00", value: "Europe/Zagreb UTC+01:00"},
	{text: "Europe/Zaporozhye UTC+02:00", value: "Europe/Zaporozhye UTC+02:00"},
	{text: "Europe/Zurich UTC+01:00", value: "Europe/Zurich UTC+01:00"},
	// Indian
	{text: "Indian/Antananarivo UTC+03:00", value: "Indian/Antananarivo UTC+03:00"},
	{text: "Indian/Chagos UTC+06:00", value: "Indian/Chagos UTC+06:00"},
	{text: "Indian/Christmas UTC+07:00", value: "Indian/Christmas UTC+07:00"},
	{text: "Indian/Cocos UTC+06:30", value: "Indian/Cocos UTC+06:30"},
	{text: "Indian/Comoro UTC+03:00", value: "Indian/Comoro UTC+03:00"},
	{text: "Indian/Kerguelen UTC+05:00", value: "Indian/Kerguelen UTC+05:00"},
	{text: "Indian/Mahe UTC+04:00", value: "Indian/Mahe UTC+04:00"},
	{text: "Indian/Maldives UTC+05:00", value: "Indian/Maldives UTC+05:00"},
	{text: "Indian/Mauritius UTC+04:00", value: "Indian/Mauritius UTC+04:00"},
	{text: "Indian/Mayotte UTC+03:00", value: "Indian/Mayotte UTC+03:00"},
	{text: "Indian/Reunion UTC+04:00", value: "Indian/Reunion UTC+04:00"},
	// Pacific
	{text: "Pacific/Apia UTC+13:00", value: "Pacific/Apia UTC+13:00"},
	{text: "Pacific/Auckland UTC+12:00", value: "Pacific/Auckland UTC+12:00"},
	{text: "Pacific/Bougainville UTC+11:00", value: "Pacific/Bougainville UTC+11:00"},
	{text: "Pacific/Chatham UTC+12:45", value: "Pacific/Chatham UTC+12:45"},
	{text: "Pacific/Chuuk UTC+10:00", value: "Pacific/Chuuk UTC+10:00"},
	{text: "Pacific/Easter UTC-06:00", value: "Pacific/Easter UTC-06:00"},
	{text: "Pacific/Efate UTC+11:00", value: "Pacific/Efate UTC+11:00"},
	{text: "Pacific/Enderbury UTC+13:00", value: "Pacific/Enderbury UTC+13:00"},
	{text: "Pacific/Fakaofo UTC+13:00", value: "Pacific/Fakaofo UTC+13:00"},
	{text: "Pacific/Fiji UTC+12:00", value: "Pacific/Fiji UTC+12:00"},
	{text: "Pacific/Funafuti UTC+12:00", value: "Pacific/Funafuti UTC+12:00"},
	{text: "Pacific/Galapagos UTC-06:00", value: "Pacific/Galapagos UTC-06:00"},
	{text: "Pacific/Gambier UTC-09:00", value: "Pacific/Gambier UTC-09:00"},
	{text: "Pacific/Guadalcanal UTC+11:00", value: "Pacific/Guadalcanal UTC+11:00"},
	{text: "Pacific/Guam UTC+10:00", value: "Pacific/Guam UTC+10:00"},
	{text: "Pacific/Honolulu UTC-10:00", value: "Pacific/Honolulu UTC-10:00"},
	{text: "Pacific/Kiritimati UTC+14:00", value: "Pacific/Kiritimati UTC+14:00"},
	{text: "Pacific/Kosrae UTC+11:00", value: "Pacific/Kosrae UTC+11:00"},
	{text: "Pacific/Kwajalein UTC+12:00", value: "Pacific/Kwajalein UTC+12:00"},
	{text: "Pacific/Majuro UTC+12:00", value: "Pacific/Majuro UTC+12:00"},
	{text: "Pacific/Marquesas UTC-09:30", value: "Pacific/Marquesas UTC-09:30"},
	{text: "Pacific/Midway UTC-11:00", value: "Pacific/Midway UTC-11:00"},
	{text: "Pacific/Nauru UTC+12:00", value: "Pacific/Nauru UTC+12:00"},
	{text: "Pacific/Niue UTC-11:00", value: "Pacific/Niue UTC-11:00"},
	{text: "Pacific/Norfolk UTC+11:00", value: "Pacific/Norfolk UTC+11:00"},
	{text: "Pacific/Noumea UTC+11:00", value: "Pacific/Noumea UTC+11:00"},
	{text: "Pacific/Pago_Pago UTC-11:00", value: "Pacific/Pago_Pago UTC-11:00"},
	{text: "Pacific/Palau UTC+09:00", value: "Pacific/Palau UTC+09:00"},
	{text: "Pacific/Palm_Spring UTC-08:00", value: "Pacific/Palm_Spring UTC-08:00"},
	{text: "Pacific/Papeete UTC-10:00", value: "Pacific/Papeete UTC-10:00"},
	{text: "Pacific/Pitcairn UTC-08:00", value: "Pacific/Pitcairn UTC-08:00"},
	{text: "Pacific/Pohnpei UTC+11:00", value: "Pacific/Pohnpei UTC+11:00"},
	{text: "Pacific/Ponape UTC+11:00", value: "Pacific/Ponape UTC+11:00"},
	{text: "Pacific/Port_Moresby UTC+10:00", value: "Pacific/Port_Moresby UTC+10:00"},
	{text: "Pacific/Rarotonga UTC-10:00", value: "Pacific/Rarotonga UTC-10:00"},
	{text: "Pacific/Saipan UTC+10:00", value: "Pacific/Saipan UTC+10:00"},
	{text: "Pacific/Samoa UTC+13:00", value: "Pacific/Samoa UTC+13:00"},
	{text: "Pacific/Tahiti UTC-10:00", value: "Pacific/Tahiti UTC-10:00"},
	{text: "Pacific/Tarawa UTC+12:00", value: "Pacific/Tarawa UTC+12:00"},
	{text: "Pacific/Tongatapu UTC+13:00", value: "Pacific/Tongatapu UTC+13:00"},
	{text: "Pacific/Truk UTC+10:00", value: "Pacific/Truk UTC+10:00"},
	{text: "Pacific/Wake UTC+12:00", value: "Pacific/Wake UTC+12:00"},
	{text: "Pacific/Wallis UTC+12:00", value: "Pacific/Wallis UTC+12:00"},
	{text: "Pacific/Yap UTC+10:00", value: "Pacific/Yap UTC+10:00"}
];

export const DEFAULT_TIMEZONE = 'Asia/Dhaka UTC+06:00';

